module.exports = __webpack_public_path__ + "static/media/CastroDanielResume.2fd7b9fc.pdf";